module.exports = __webpack_public_path__ + "static/polar-designTemplate-min-06b8174e0861ff6cf3463d12c27bc2c3.jpg";